import { request } from '../utils';
import { toast, alert } from '../components';

export default function zan(skuIds, lencom, callback) {
    alert('确定要删除这' + lencom + '种商品吗?', [
        '先留着',
        {
            text: '删除', onClick: () => {
                request('newproduct/carts/v1/delete', {
                    skuIds: skuIds,
                }).then((rd) => {
                    if (rd.errCode == '204') {
                        callback();
                    } else {
                        toast(rd.errDesc);
                    }
                });
            }
        }
    ]);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/delShop.ts